import React, { Component } from 'react';
import { ListLink, NavLink } from '../../components/NavLink'
import NavBar from '../../components/NavBar'
import actions from '../../actions'
import { connect } from 'react-redux'
import HomeIcon from '@material-ui/icons/Home';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { push } from 'react-router-redux'

class Unauthorized extends Component {

    handleVerifyEmail = () => {
        const { dispatch, handleVerifyEmail } = this.props
        dispatch(handleVerifyEmail())
    }

    login = () => {
        const { dispatch } = this.props
        dispatch(push('/login'));
    }
    render () {
        return (
            <div>
                <div className="marketing-wrapper">
                    <nav className="navbar-default">
                        <div className="container">
                          <NavBar>
                            <ListLink to="/">
                                <ListItem button>
                                <ListItemIcon>
                                    <HomeIcon color="secondary" />
                                </ListItemIcon>
                                <ListItemText primary="Driftsplaner" />
                                </ListItem>
                            </ListLink>
                          </NavBar>
                        </div>
                    </nav>
                    <div className="text-center container unauthorized">
                        <h1>Du har ikke adgang til driftsplaner.</h1>
                        <p>Dette kan også skyldes du ikke har verificeret din email.</p>
                        <p>Hvis du ikke har modtaget en bekræftigelsesmail, kan du klikke herunder for at få sendt en ny</p>
                        <button onClick={this.login} className="btn btn-primary mr-1">Log ind igen</button>
                        <button onClick={this.handleVerifyEmail} className="btn btn-primary">Send mail</button>
                    </div>
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
  return {
  }
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    handleVerifyEmail: actions.sendVerificationMail,
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Unauthorized)
